export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8180.9e46a045.jpg";